"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * Typography
 */


var fontWeight = {
  fontWeightExtraLight: 200,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  fontWeightBlack: 900
};

var _default = _objectSpread(_objectSpread({}, fontWeight), {}, {
  fontFamily: "'Source Sans Pro', sans-serif",
  h1: {
    fontWeight: fontWeight.fontWeightLight,
    fontSize: 96,
    letterSpacing: -1.5,
    lineHeight: '112px'
  },
  h2: {
    fontWeight: fontWeight.fontWeightLight,
    size: 60,
    letterSpacing: -0.5,
    lineHeight: '72px'
  },
  h3: {
    fontWeight: fontWeight.fontWeightRegular,
    fontSize: 48,
    lineHeight: '56px'
  },
  h4: {
    fontWeight: fontWeight.fontWeightBold,
    fontSize: 34,
    letterSpacing: 0.25,
    lineHeight: '42px'
  },
  h5: {
    fontWeight: fontWeight.fontWeightBold,
    fontSize: 20,
    lineHeight: '27px'
  },
  h6: {
    fontWeight: fontWeight.fontWeightSemiBold,
    fontSize: 18,
    letterSpacing: 0.15,
    lineHeight: '29px'
  },
  body1: {
    fontWeight: fontWeight.fontWeightRegular,
    fontSize: 16,
    letterSpacing: 0.15,
    lineHeight: '24px'
  },
  body2: {
    fontWeight: fontWeight.fontWeightRegular,
    fontSize: 14,
    letterSpacing: 0.15,
    lineHeight: '20px'
  },
  subtitle1: {
    fontWeight: fontWeight.fontWeightRegular,
    fontSize: 16,
    letterSpacing: 0.15,
    lineHeight: '28px'
  },
  subtitle2: {
    fontWeight: fontWeight.fontWeightRegular,
    fontSize: 14,
    letterSpacing: 0.1,
    lineHeight: '22px'
  },
  caption: {
    fontWeight: fontWeight.fontWeightRegular,
    fontSize: 12,
    letterSpacing: 0.4,
    lineHeight: '20px'
  },
  overline: {
    fontWeight: fontWeight.fontWeightRegular,
    fontSize: 12,
    letterSpacing: 1,
    lineHeight: '32px',
    textTransform: 'uppercase'
  },
  button: {
    fontWeight: fontWeight.fontWeightBold,
    fontSize: 14,
    letterSpacing: 0.4,
    lineHeight: '24px',
    textTransform: 'uppercase'
  },
  special: {
    h4InBar: {
      fontWeight: fontWeight.fontWeightBold,
      fontSize: 24,
      letterSpacing: 0.25,
      lineHeight: '30px'
    },
    h5SemiBold: {
      fontWeight: fontWeight.fontWeightSemiBold,
      fontSize: 20,
      lineHeight: '27px'
    },
    body1Bold: {
      fontWeight: fontWeight.fontWeightBold,
      fontSize: 16,
      letterSpacing: 0.15,
      lineHeight: '24px'
    },
    body2Bold: {
      fontWeight: fontWeight.fontWeightBold,
      fontSize: 14,
      letterSpacing: 0.15,
      lineHeight: '20px'
    }
  }
});

exports["default"] = _default;